import { createApp } from 'vue'
import ScheduledEvents from '../../components/scheduled_events'
import LatestArchivedEvents from '../../components/latest_archived_events'
import VerticalEventArchiveTagsEvents from '../../components/event_tags/vertical-events'
import EventTagsEvents from '../../components/event_tags/events'
import dataPropsParser from '../../data_props_parser'

const mountApp = (element, component) => {
  const dataProps = dataPropsParser(element.dataset.props)
  const app = createApp(component, dataProps)
  app.mount(`#${element.id}`)
}

document.addEventListener('DOMContentLoaded', () => {
  const scheduledApp = createApp(ScheduledEvents)
  scheduledApp.mount('#vue_scheduled_event_carousel')

  const latestApp = createApp(LatestArchivedEvents)
  latestApp.mount('#vue_latest_archived_event_carousel')

  const carouselElements = document.getElementsByClassName('vue_carousel')
  Array.prototype.forEach.call(carouselElements, element => {
    mountApp(element, EventTagsEvents)
  })

  const verticalEventElements = document.getElementsByClassName('vertical-event')
  Array.prototype.forEach.call(verticalEventElements, element => {
    mountApp(element, VerticalEventArchiveTagsEvents)
  })
})
